<template>
    <div class="pin-input-group">
      <input
        v-for="(digit, index) in digits"
        :key="index"
        v-model="digits[index]"
        type="text"
        maxlength="1"
        class="pin-input"
        @input="onInput(index)"
        @keydown="onKeyDown(index, $event)"
        :ref="el => setRef(index, el)"
        :disabled="isDisabled(index)"
      />
    </div>
  </template>
  
<script setup>
import { defineEmits, ref, reactive, onMounted, nextTick } from 'vue';

const emit = defineEmits(['update:otp']);
const digits = reactive(['', '', '', '', '', '']);
const inputRefs = ref([]);

const setRef = (index, el) => {
    inputRefs.value[index] = el;
};

onMounted(() => {
    nextTick(() => {
        inputRefs.value[0]?.focus();
    });
});

const isDisabled = (index) => {
    if (index === 0) return false;
    return digits.slice(0, index).some(d => d === '');
};

const onInput = (index) => {
    const digit = digits[index];
    if (!/^\d$/.test(digit)) {
        digits[index] = ''; // allow only 1 digit 0-9
        return;
    }

    // Move to next field
    if (index < 5) {
        nextTick(() => inputRefs.value[index + 1]?.focus());
    }

    emit('update:otp', digits.join(''))
};
  
const onKeyDown = (index, event) => {
    if (event.key === 'Backspace') {
        event.preventDefault();

        if (digits[index] === '') {
        // current is empty, go back and clear previous
        if (index > 0) {
            digits[index - 1] = '';
            nextTick(() => inputRefs.value[index - 1]?.focus());
        }
        } else {
            // clear current and stay
            digits[index] = '';
        }

        emit('update:otp', digits.join(''))
    }
};
</script>

<style scoped>
.pin-input-group {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 3rem;
    margin-bottom: 3.5rem;
}

.pin-input {
    width: 40px;
    height: 50px;
    text-align: center;
    font-size: 24px;
    border: 1px solid #ccc;
    border-radius: 6px;
}
</style>
  